import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  width: "25",
  height: "25",
  class: "t-sociallinks__svg",
  viewBox: "0 0 99 99"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M49 98a49 49 0 1 0 0-98 49 49 0 0 0 0 98M22 34c.4 21.3 11.1 34.1 29.8 34.1h1V56c7 .7 12.1 5.7 14.2 12.2h9.7a27 27 0 0 0-14-17 26 26 0 0 0 12-17.1h-8.9c-1.9 6.8-7.5 13-13 13.5V34H44v23.6c-5.4-1.3-12.3-8-12.6-23.6z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }